import { ThunkAction } from 'redux-thunk';
import { Action, combineReducers, configureStore, ThunkDispatch } from '@reduxjs/toolkit';
import { ConnectedProps, TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { promptTypeSlice } from './prompt-type-store';
import { oauthSlice } from './oauth-store';
import { userSlice } from './user-auth-store';
import { providerSlice } from './provider-store';
import { applicationSlice } from './app-state-store';
import { paymentDetailsSlice } from './payment-store';
import { credentialsSlice } from './credentials-store';
import { transferSlice } from './transfer-store';
import { accountsSlice } from './account-store';
import { sessionSlice } from './session-store';
import { userCredentialsSlice } from './user-credentials-store';
import { selectedProviderSlice } from './selected-provider-store';
import { accountCheckSlice } from './account-check-store';
import { handoffSessionSlice } from './handoff-session-store';
import { reportsSlice } from './reports-store';
import { riskInsightsSlice } from './risk-insights-store';
import { paymentTransferDetailsSlice } from './payment-transfer-store';

export const rootReducer = combineReducers({
  user: userSlice.reducer,
  oauth: oauthSlice.reducer,
  credentials: credentialsSlice.reducer,
  providers: providerSlice.reducer,
  application: applicationSlice.reducer,
  paymentDetails: paymentDetailsSlice.reducer,
  paymentTransferDetails: paymentTransferDetailsSlice.reducer,
  transfer: transferSlice.reducer,
  accounts: accountsSlice.reducer,
  session: sessionSlice.reducer,
  userCredentials: userCredentialsSlice.reducer,
  selectedProvider: selectedProviderSlice.reducer,
  accountCheck: accountCheckSlice.reducer,
  handoffSession: handoffSessionSlice.reducer,
  reports: reportsSlice.reducer,
  riskInsights: riskInsightsSlice.reducer,
  promptType: promptTypeSlice.reducer,
});

export type AppThunk = ThunkAction<void, AppState, null, Action<string>>;

export type AppState = ReturnType<typeof rootReducer>;

// infers make the generic type not parsable by strict keyof
// eslint-disable-next-line @typescript-eslint/ban-types
export type ConnectedPropsWithoutDispatch<T> = Omit<ConnectedProps<T>, 'dispatch'>;

export const store = configureStore({
  reducer: rootReducer,
});

export type AppDispatch = ThunkDispatch<AppState, null, Action<string>>;

export const useAppDispatch = () => useDispatch<AppDispatch>();

export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;
